import { Modal } from "react-bootstrap";
import React, { useEffect } from 'react';
import axios from "axios";
import swal from '@sweetalert/with-react'
import './custom.css'
const MyVerticallyCenteredModal = (props) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const handleSubmit = e => {
        e.preventDefault();
        axios
            .post(`${process.env.REACT_APP_API_LINK}userInfo`, {
                name: e.target.name.value,
                email: e.target.email.value,
            })
            .then(res => {
                // alert(res.data.message);
                swal(

                    <div>
                        <img className="w-50" src="/img/successAnim.gif" alt="" />
                        <h1>Hi {e.target.name.value}!</h1>
                        <p>
                            We will send you the app invite soon.
                        </p>
                    </div>
                )
                props.onHide();
                e.target.reset();
                props.show()
            });
    };
    return (
        <Modal
            style={{ borderRadius: '50px' }}
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="mt-4 "
        >

            <Modal.Body>
                <div className="d-flex justify-content-end">
                    <i className="fa fa-times" onClick={props.onHide} aria-hidden="true" style={{ fontSize: '20px', cursor: 'pointer' }}></i>
                </div>
                <div className="d-flex justify-content-center py-5">
                    <form onSubmit={handleSubmit}>
                        <div className="d-flex justify-content-center">
                            <img src="/img/modal_email.png" className="w-25" alt="" /><br />
                        </div>
                        <p className="text-center mt-4 fw-bold text-dark modalText" style={{ fontFamily: 'Poppins', lineHeight: '30px' }}>Join the movement to reduce <br /> carbon emissions today.</p>
                        <div className="d-flex justify-content-center">
                            <div>
                                <input name="name" style={{ border: "0.5px solid gray", borderRadius: '5px' }} className="modalInput my-2 py-2 px-3" required placeholder="Your Name" type="text" /><br />
                                <input name='email' style={{ border: "0.5px solid gray", borderRadius: '5px' }} className="modalInput my-2 py-2 px-3" required type="email" placeholder="Your Email Address" /> <br />
                                <input className="modalInput mt-1 btn btn-primary" type="submit" value="Register" />
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MyVerticallyCenteredModal;